import React, { useEffect, useState } from "react";
import { Button, Col, Flex, message, Row, Spin } from "antd";
import "./style.css";
import API from "../../services/api-request";

const SelectRack = ({
  data,
  location,
  onRackSelect,
  action,
  open,
  reloadKey,
}) => {
  const [selectedStorage, setSelectedStorage] = useState(null);
  const [loading, setLoading] = useState(false);

  const id = data?.id;
  const row_number = data?.row;
  const section = data?.section;
  const name = data?.name;

  const getAreaData = () => {
    setLoading(true);

    API.Get(`area/map?warehouseId=${id}`)
      .then((res) => {
        const data = res?.data;

        const findStorage = data?.[0]?.rows?.find(
          (row) => row.row_number === row_number
        );

        const matchedSection = findStorage?.sections?.find(
          (sec) => sec.section === section
        );

        setSelectedStorage(matchedSection);
      })
      .catch((err) => {
        console.log(err);
        message.error("Failed to fetch area data!");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const getAreaDetail = (rack) => {
    setLoading(true);
    API.Get(`area/${rack.id}/stock`)
      .then((res) => {
        onRackSelect?.({ ...rack, pallet_id: res.data.pallet_id });
      })
      .catch((err) => {
        console.log(err);
        message.info(`${err?.response?.data?.error}`);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const onSelectRack = (rack, column_name) => {
    const isOccupied = rack?.status === "occupied";
    const isMergeAction = action?.toLowerCase() === "merge";
    const hasEmptyRacks =
      selectedStorage.empty_areas > 0 && column_name === "T";

    if (isOccupied && !isMergeAction) {
      message.info("Rack is occupied. Please select empty rack");
      return;
    }

    if (!isOccupied && isMergeAction) {
      message.info("Please select rack with pallet");
      return;
    }

    if (hasEmptyRacks) {
      message.info("There is empty rack available. Please select other rack");
      return;
    }

    if (isMergeAction) {
      getAreaDetail(rack);
      return;
    }

    onRackSelect?.(rack);
  };

  useEffect(() => {
    getAreaData();
  }, [location, reloadKey]);

  return (
    <>
      {loading ? (
        <Flex align="center" justify="center">
          <Spin size="large" />
        </Flex>
      ) : (
        <>
          <Flex justify="center" align="center">
            {(selectedStorage?.section === "A"
              ? [...selectedStorage?.columns].reverse()
              : selectedStorage?.columns
            )
              ?.reduce((acc, column) => {
                if (column.column_name === "S") {
                  return [column, ...acc];
                }
                return [...acc, column];
              }, [])
              ?.map((column, index) => (
                <Row gutter={0} key={index}>
                  <Col span={24}>
                    {column?.levels
                      ?.slice()
                      .reverse()
                      .map((rack, index) => (
                        <div style={{ width: "100%" }} key={index}>
                          <Button
                            variant="outlined"
                            className={`rack ${
                              column.column_name === "T"
                                ? "rack-temporary"
                                : rack?.status === "empty"
                                ? "rack-available"
                                : "rack-unavailable"
                            }`}
                            onClick={() => onSelectRack(rack)}
                          >
                            <Row gutter={0} style={{ width: "6rem" }}>
                              <Col span={24} style={{ fontSize: "24px" }}>
                                {rack.level}
                              </Col>
                              {rack.status === "occupied" && (
                                <>
                                  <Col
                                    span={24}
                                    style={{ fontWeight: "normal" }}
                                  >
                                    {rack.pallet_name}
                                  </Col>
                                  <Col
                                    span={24}
                                    style={{ fontWeight: "normal" }}
                                  >
                                    {rack.client_name}
                                  </Col>
                                  <Col
                                    span={24}
                                    style={{ fontWeight: "normal" }}
                                  >
                                    {rack.total_weight} Kg
                                  </Col>
                                </>
                              )}
                            </Row>
                          </Button>
                        </div>
                      ))}
                  </Col>
                  <Col span={24}>
                    <p
                      style={{
                        textAlign: "center",
                        fontWeight: "bold",
                        fontSize: "1.5rem",
                      }}
                    >
                      {column.column_name}
                    </p>
                  </Col>
                </Row>
              ))}
          </Flex>
          {!name.includes("Temporary") && (
            <Flex gap={10}>
              <div
                style={{ display: "flex", alignItems: "center", gap: "5px" }}
              >
                <div
                  style={{
                    width: "1rem",
                    height: "1rem",
                    backgroundColor: "#d32526",
                    display: "inline-block",
                    borderRadius: "5px",
                  }}
                />
                <span> Unvailable</span>
              </div>
              <div
                style={{ display: "flex", alignItems: "center", gap: "5px" }}
              >
                <div
                  style={{
                    width: "1rem",
                    height: "1rem",
                    backgroundColor: "#26d3a6",
                    display: "inline-block",
                    borderRadius: "5px",
                  }}
                />
                <span> Available</span>
              </div>
            </Flex>
          )}
        </>
      )}
    </>
  );
};

export default SelectRack;
